import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import format from "date-fns/format";
import * as dfn from "date-fns/fp";
import ro from "date-fns/locale/ro";
import { DataGrid, SelectBox } from "devextreme-react";
import Button from "devextreme-react/button";
import { ButtonGroup } from "devextreme-react/button-group";
import Calendar from "devextreme-react/calendar";
import { DataGridRef } from "devextreme-react/data-grid";
//devex
import Form, {
  AsyncRule,
  ButtonItem,
  FormRef,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import TabPanel from "devextreme-react/tab-panel";
import { Button as TextBoxButton, TextBox } from "devextreme-react/text-box";
import { confirm } from "devextreme/ui/dialog";
/* -------------------------------------------------------------------------- */
import { isEmpty, stubFalse } from "lodash";
import omit from "lodash/omit";
import { useTranslation } from "react-i18next";
import resso from "resso";
import { useDebouncedCallback } from "use-debounce";

import { Case, CaseElse, Switch } from "@app/contexts";
import { ensureArray, isTrusted, noCase } from "@app/service/helpers";
import {
  CONST_LISTORIGIN_INVOICE,
  CONST_LISTORIGIN_PROFORMA,
  CONST_LISTORIGIN_WORK,
} from "@app/state/insider/constants";
import { select_api_login_amaid } from "@app/state/insider/login";
import {
  listPrepareSetModel,
  listQueryStateCondOptionsForListByName,
  listQueryStateShowConditionForListByName,
  listReportsSetTempUiKV,
  select_titlesIgnoreCase,
  selectListReportUi_currentListOpsData,
  slectListReportLoadedID,
} from "@app/state/insider/ui/uiList";
//
// import { useFxSelector } from '@app/statefx';
// import { schema } from '@app/statefx/schema';
// helpers //
import { commonStyle } from "@app/style/commonForms";
import { ILxReportOption, TUndoableOparationPayload } from "@app/types/insider";

import { useAppDispatch, useAppSelector } from "../../state";
import "./lists_common.scss";

/* -------------------------------------------------------------------------- */

const forcedDefaultInterval = {
  start: dfn.format(
    "yyyy-MM-dd",
    new Date(dfn.startOfMonth(dfn.subYears(1, new Date())))
  ),
  end: dfn.format("yyyy-MM-dd", new Date()),
  zero: dfn.format("yyyy-MM-dd", new Date(0)),
  final: dfn.format("yyyy-MM-dd", dfn.endOfYear(new Date())),
};

type TLocalMywo = {
  selectedTab: "GROUP" | "USER";
  selectedIndex: number;
  uSelectedPeriod: {
    start: string;
    end: string;
  };
  gSelectedPeriod: {
    start: string;
    end: string;
  };
  setPeriod: (
    key: TLocalMywo["selectedTab"],
    period: TLocalMywo["uSelectedPeriod"]
  ) => void;
};
export const localMywo = resso<TLocalMywo>({
  selectedTab: "USER",
  selectedIndex: 0,
  uSelectedPeriod: {
    start: forcedDefaultInterval.zero,
    end: forcedDefaultInterval.final,
  },
  gSelectedPeriod: {
    start: forcedDefaultInterval.zero,
    end: forcedDefaultInterval.final,
  },
  setPeriod: (key, period) => {
    if (key === "USER") {
      localMywo.uSelectedPeriod = period;
    }
    if (key === "GROUP") {
      localMywo.gSelectedPeriod = period;
    }
  },
});
type TLocalInvoices = {
  selectedCurrency: string; // this goes all the way to the server //
  selectedEmitent: string; // this goes all the way to the server //
};
export const localInvoices = resso<TLocalInvoices>({
  selectedCurrency: "EUR",
  selectedEmitent: "",
}); // todo //
const dateLocales = { ro: ro };

/* 	id: item.KLR_ID,
    group: item.KLR_GROUP,
    name: item.LIST_NAME,
    displayName: item.LIST_DISPLAY_NAME,
    text: item.TEXT,
    access: item.ACCESS,
    readonly: Boolean(+item.READONLY),
    ownerAma: item.OWNER_AMA, 
  */

export const ActiveListModelSave = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const anyListGridRef = useRef<DataGridRef>(null);
  const formformref = useRef<FormRef>(null);
  const dataRef: React.MutableRefObject<any> = useRef({});

  const [, jet] = useState(0);
  const theSelectingState: Partial<ILxReportOption> = useAppSelector(
    selectListReportUi_currentListOpsData
  );
  const theNormNames = useAppSelector(select_titlesIgnoreCase);
  const commonTextEditOptions = {
    ...commonStyle({ elementclass: "filledunderline" }),
  };
  // todo or not //
  const isDirty = () => false;
  // todo //
  const isReadOnly = useMemo(() => false, []);

  const fieldDataChanged = (e: any) => {
    let { value } = e || {};
    const { dataField } = e || {};
    if (!dataField) {
      return;
    }
    if (value === "") {
      value = null;
    }
    const newState = { ...dataRef.current, [dataField]: value };
    dataRef.current = newState;
  };
  useEffect(() => {
    console.log(
      "FINDME PROPS ELEMENT-ATTR - data-layoutID ::: anyListGridRef.current",
      anyListGridRef.current
    );
    if (JSON.stringify(dataRef.current) !== JSON.stringify(theSelectingState)) {
      dataRef.current = { ...theSelectingState };
      jet(Math.random());
    }
  }, [JSON.stringify(theSelectingState)]);

  const customizeFormIems = (item: any) => {
    item.editorOptions = { ...commonTextEditOptions, ...item.editorOptions };
  };
  const textAreaEditorOptions = {
    minHeight: "12ch",
    maxLength: "12ch",
  };
  const accessEditorOptions = {
    value: dataRef.current["access"] === "PUBLIC",
    switchedOffText: "PRIVAT",
    switchedOnText: "PUBLIC",
  };

  const buttonOptions = {
    text: "Salveaza",
    type: "normal",
    stylingMode: "outlined",
    icon: "save",
    useSubmitBehavior: true,
  } as any;
  const onFormSubmit = (e: any) => {
    e.preventDefault();

    if (anyListGridRef && anyListGridRef.current) {
      console.log("findmeeeee 009900");
      const crtState = anyListGridRef.current.instance().state();
      const crtState2 = Object.assign({}, crtState, {
        layoutID: 2,
        // anyListGridRef.current?.props?.elementAttr?.["data-layoutID"] ?? 2,
      });
      const theNewState = {
        ...dataRef.current,
        state: crtState2,
      } as ILxReportOption;
      dispatch(listPrepareSetModel({ SAVE: theNewState }));
      e.stopPropagation();
    }
  };
  const validateme = useCallback(async ({ value }: { value: any }) => {
    // forced promise //
    return new Promise((resolve, reject) => {
      resolve(theNormNames.filter((n) => n === noCase(value)).length <= 1);
    });
  }, []);
  return (
    <form onSubmit={onFormSubmit}>
      <Form
        ref={formformref}
        id={"formformLxModelSave"}
        className={`form-form org-data ${isDirty() ? "edited" : ""}`}
        formData={{ ...dataRef.current }}
        showColonAfterLabel={true}
        labelLocation={"left"}
        colCount={3}
        width={400}
        onFieldDataChanged={fieldDataChanged}
        readOnly={isReadOnly}
        customizeItem={customizeFormIems}
      >
        <SimpleItem
          editorOptions={commonTextEditOptions}
          dataField="displayName"
          label={{ text: t("contacts_orgInvoiceName"), location: "top" }}
          colSpan={3}
        >
          <RequiredRule message={t("listreportname_required")} />
          <AsyncRule
            message={t("listreportname_exists")}
            validationCallback={validateme}
          />
        </SimpleItem>
        <SimpleItem
          editorType="dxTextArea"
          editorOptions={textAreaEditorOptions}
          dataField="text"
          label={{ text: t("contacts_orgInvoiceAddress_1"), location: "top" }}
          colSpan={3}
        />
        <SimpleItem
          colSpan={2}
          dataField={"access"}
          editorType={"dxSwitch"}
          editorOptions={accessEditorOptions}
          label={{ text: "Partajare cu colegii", location: "left" }}
        />
        <ButtonItem horizontalAlignment="left" buttonOptions={buttonOptions} />
      </Form>
    </form>
  );
};

export const ActiveListModelSaveAs = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const anyListGridRef = useRef<DataGridRef>(null);
  const formformref = useRef<FormRef>(null);
  const dataRef: React.MutableRefObject<any> = useRef({});
  const [, jet] = useState(0);
  const theSelectingState: Partial<ILxReportOption> = useAppSelector(
    selectListReportUi_currentListOpsData
  );
  const theNormNames = useAppSelector(select_titlesIgnoreCase);
  const commonTextEditOptions = {
    ...commonStyle({ elementclass: "filledunderline" }),
  };
  // todo or not //
  const isDirty = () => false;
  // todo //
  const isReadOnly = useMemo(() => false, []);

  const fieldDataChanged = (e: any) => {
    const { dataField } = e || {};
    let { value } = e || {};
    if (!dataField) {
      return;
    }
    if (value === "") {
      value = null;
    }
    const newState = { ...dataRef.current, [dataField]: value };
    dataRef.current = newState;
  };
  useEffect(() => {
    if (JSON.stringify(dataRef.current) !== JSON.stringify(theSelectingState)) {
      dataRef.current = { ...theSelectingState };
      jet(Math.random());
    }
  }, [JSON.stringify(theSelectingState)]);

  const customizeFormIems = (item: any) => {
    item.editorOptions = { ...commonTextEditOptions, ...item.editorOptions };
  };
  const textAreaEditorOptions = {
    minHeight: "12ch",
    maxLength: "12ch",
  };
  const accessEditorOptions = {
    value: dataRef.current["access"] === "PUBLIC",
    switchedOffText: "PRIVAT",
    switchedOnText: "PUBLIC",
  };
  const buttonOptions = {
    text: "Salveaza",
    type: "normal",
    stylingMode: "outlined",
    icon: "save",
    useSubmitBehavior: true,
  } as any;
  const onFormSubmit = (e: any) => {
    e.preventDefault();
    if (!anyListGridRef || !anyListGridRef.current) {
      return;
    }
    const crtState = anyListGridRef.current.instance().state();
    console.log("findmeeeee 009900-2");
    const crtState2 = Object.assign({}, crtState, {
      layoutID: 1,
      // anyListGridRef.current.props.elementAttr?.["data-layoutID"] ?? 1,
    });
    const theNewState = {
      ...dataRef.current,
      state: crtState2,
    } as ILxReportOption;
    dispatch(listPrepareSetModel({ SAVEAS: theNewState }));
    e.stopPropagation();
  };
  const validateme = useCallback(async ({ value }: { value: any }) => {
    // forced promise //
    return new Promise((resolve, reject) => {
      resolve(!theNormNames.includes(noCase(value)));
    });
  }, []);
  return (
    <form onSubmit={onFormSubmit}>
      <Form
        ref={formformref}
        id={"formformLxModelSaveAs"}
        className={`form-form org-data ${isDirty() ? "edited" : ""}`}
        formData={{ ...dataRef.current }}
        showColonAfterLabel={true}
        labelLocation={"left"}
        colCount={3}
        width={400}
        onFieldDataChanged={fieldDataChanged}
        readOnly={isReadOnly}
        customizeItem={customizeFormIems}
      >
        <SimpleItem
          editorOptions={commonTextEditOptions}
          dataField="displayName"
          label={{ text: t("contacts_orgInvoiceName"), location: "top" }}
          colSpan={3}
        >
          <RequiredRule message={t("listreportname_required")} />
          <AsyncRule
            message={t("listreportname_exists")}
            validationCallback={validateme}
          />
        </SimpleItem>

        <SimpleItem
          editorType="dxTextArea"
          editorOptions={textAreaEditorOptions}
          dataField="text"
          label={{ text: t("contacts_orgInvoiceAddress_1"), location: "top" }}
          colSpan={3}
        />
        <SimpleItem
          colSpan={2}
          dataField={"access"}
          editorType={"dxSwitch"}
          editorOptions={accessEditorOptions}
          label={{ text: "Partajare cu colegii", location: "left" }}
        />
        <ButtonItem horizontalAlignment="left" buttonOptions={buttonOptions} />
      </Form>
    </form>
  );
};

export const OtherListModelSaveAs = ({
  list,
  operation,
}: {
  list: Partial<ILxReportOption>;
  operation: "SAVEACOPY" | "RENAME";
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const formformref = useRef<FormRef>(null);
  const dataRef: React.MutableRefObject<any> = useRef({});
  const [, jet] = useState(0);
  const theNormNames = useAppSelector(select_titlesIgnoreCase);
  const theSelectingState = list;
  const commonTextEditOptions = {
    ...commonStyle({ elementclass: "filledunderline" }),
  };
  // todo or not //
  const isDirty = () => false;
  // todo //
  const isReadOnly = useMemo(() => false, []);

  const fieldDataChanged = (e: any) => {
    if (isTrusted(e)) {
      return;
    }
    const { dataField } = e || {};
    let { value } = e || {};
    if (!dataField) {
      return;
    }
    if (value === "") {
      value = null;
    }
    const newState = { ...dataRef.current, [dataField]: value };
    dataRef.current = newState;
  };
  useEffect(() => {
    if (JSON.stringify(dataRef.current) !== JSON.stringify(theSelectingState)) {
      dataRef.current = { ...theSelectingState };
      jet(Math.random());
    }
  }, [JSON.stringify(theSelectingState)]);

  const customizeFormIems = (item: any) => {
    item.editorOptions = { ...commonTextEditOptions, ...item.editorOptions };
  };
  const textAreaEditorOptions = {
    elmentAttr: { style: { height: "12ch" } },
    minHeight: "12ch",
    maxLength: "12ch",
  };
  const accessEditorOptions = {
    value: dataRef.current["access"] === "PUBLIC",
    switchedOffText: "PRIVAT",
    switchedOnText: "PUBLIC",
  };
  const buttonOptions = {
    text: operation === "SAVEACOPY" ? "Crează copia" : "Modifică",
    type: "normal",
    stylingMode: "outlined",
    icon: operation === "SAVEACOPY" ? "copy" : "save",
    useSubmitBehavior: true,
  } as any;
  const onFormSubmit = (e: any) => {
    e.preventDefault();
    const theNewState = {
      ...dataRef.current,
      state: null,
    } as ILxReportOption;
    dispatch(listPrepareSetModel({ [operation]: theNewState }));
    e.stopPropagation();
  };

  const validateme = useCallback(async ({ value }: { value: any }) => {
    switch (operation) {
      case "SAVEACOPY":
        return new Promise((resolve, reject) => {
          resolve(!theNormNames.includes(noCase(value)));
        });
      case "RENAME":
        return new Promise((resolve, reject) => {
          const thisOriginalName = noCase(theSelectingState.displayName || "");
          resolve(
            theNormNames
              .filter((n) => n !== thisOriginalName)
              .filter((n) => n === noCase(value)).length === 0
          );
        });
      default:
        break;
    }
  }, []);
  return (
    <form onSubmit={onFormSubmit}>
      <Form
        ref={formformref}
        id={"formformLxOtherListModelSaveAs"}
        className={`form-form org-data ${isDirty() ? "edited" : ""}`}
        formData={{ ...dataRef.current }}
        showColonAfterLabel={true}
        labelLocation={"left"}
        colCount={3}
        width={400}
        onFieldDataChanged={fieldDataChanged}
        readOnly={isReadOnly}
        customizeItem={customizeFormIems}
      >
        <SimpleItem
          editorOptions={commonTextEditOptions}
          dataField="displayName"
          label={{ text: t("contacts_orgInvoiceName"), location: "top" }}
          colSpan={3}
        >
          <RequiredRule message={t("listreportname_required")} />
          <AsyncRule
            message={t("listreportname_exists")}
            validationCallback={validateme}
          />
        </SimpleItem>

        <SimpleItem
          editorType="dxTextArea"
          editorOptions={textAreaEditorOptions}
          dataField="text"
          label={{ text: t("contacts_orgInvoiceAddress_1"), location: "top" }}
          colSpan={3}
        />
        <SimpleItem
          colSpan={2}
          dataField={"access"}
          editorType={"dxSwitch"}
          editorOptions={accessEditorOptions}
          label={{ text: "Partajare cu colegii", location: "left" }}
        />
        <ButtonItem horizontalAlignment="left" buttonOptions={buttonOptions} />
      </Form>
    </form>
  );
};

export const AnyListModelDelete = ({ list }: { list: ILxReportOption }) => {
  const dispatch = useAppDispatch();
  const deleteModel = useCallback(async () => {
    const r = await confirm("Confirmati stergerea modelului?", "Stergere");
    if (!r) {
      return;
    }
    const pay = { DELETE: list.id } as TUndoableOparationPayload;

    dispatch(listPrepareSetModel(pay));
  }, []);

  return (
    <div className="grid-end">
      <Button
        text={"Sterge"}
        stylingMode={"outlined"}
        type={"danger"}
        icon={"trash"}
        onClick={deleteModel}
      />
    </div>
  );
};

export const InfoGroupHeader = () => {
  const theList: Partial<ILxReportOption> = useAppSelector(
    selectListReportUi_currentListOpsData
  );
  return (
    <div className={"rop-info"}>
      <div className="lxrinfo">
        {`Autor: ${theList.ownerAma || "Jurnal Gold"}`}
        <span className="bat">{"|"}</span>
        {`Vizibilitate: ${theList.access || "Public"}`}
        <span className="bat">{"|"}</span>
        {`Editabil: ${theList.readonly ? "Nu" : "Da"}`}
      </div>
    </div>
  );
};
export const CommandHeader = ({ list }: { list: ILxReportOption }) => {
  const { selectedTab, selectedIndex, uSelectedPeriod, gSelectedPeriod } =
    localMywo;
  const { selectedCurrency, selectedEmitent } = localInvoices;
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const theAmaId = useAppSelector(select_api_login_amaid);
  const lxReportIDLoaded = useAppSelector(slectListReportLoadedID);

  const debouncedDispatch = useDebouncedCallback(
    (action) => dispatch(action),
    700,
    { leading: true }
  );
  //[findme##438##] duplicate code - change both//
  const args = {};

  const openModel = () => {
    if (list.name.includes(CONST_LISTORIGIN_WORK)) {
      if (!theAmaId) {
        alert(
          "Probabil ca sesiunea a expirat. Cel mai probabil un refresh va rezolva problema."
        );
        return;
      }
      Object.assign(args, {
        ama: selectedTab === "USER" ? theAmaId : 0,
        start:
          selectedTab === "USER"
            ? uSelectedPeriod.start
            : gSelectedPeriod.start,
        end: selectedTab === "USER" ? uSelectedPeriod.end : gSelectedPeriod.end,
        watch: false,
      });
    }

    if (list.name.includes(CONST_LISTORIGIN_PROFORMA)) {
      //[findme##937##] duplicate code - change both//
      Object.assign(args, {
        ama: theAmaId,
        currency: selectedCurrency,
        watch: false,
      });
    }

    if (list.name.includes(CONST_LISTORIGIN_INVOICE)) {
      //[findme##1030##] duplicate code - change both//
      Object.assign(args, {
        ama: theAmaId,
        emitent: selectedEmitent,
        watch: false,
      });
    }
    debouncedDispatch(
      listReportsSetTempUiKV({
        lxReportId: list.id,
        lxReportName: list.name,
        "::sender": "showListDetails",
        args: args,
      })
    );
  };

  const closeModel = useCallback(() => {
    //TODO: #35 CommandHeader:closeModel() - unload/unsuscribe
    dispatch(listPrepareSetModel({ CLOSE: list.id }));
  }, []);

  return (
    <div className="rop-acc-command">
      <div className="float-right">
        <Button
          text={t("open")}
          stylingMode={"text"}
          type={"default"}
          onClick={openModel}
        />
        <span
          style={{
            display: lxReportIDLoaded === list.id ? "inline-block" : "none",
          }}
          className="bat"
        >
          {"|"}
        </span>
        <Button
          text={t("close")}
          stylingMode={"text"}
          type={"danger"}
          visible={lxReportIDLoaded === list.id}
          onClick={closeModel}
        />
      </div>
    </div>
  );
};
/* ---------------- MYWORK - OPTION SELECTOR - [YEAR INTERVALS,...] --------------- */

type TMyworkSelectorCrit0 = {
  startsfrom: string; //date iso
  maxInterval: number; //years
};
type TMyworkSelectorCrit = TMyworkSelectorCrit0 & {
  TITLE: string;
};

function createYearIntervals(dataset: any, key: string) {
  if (
    dataset?.[key]?.startsfrom &&
    dataset?.[key]?.maxInterval &&
    dfn.isValid(new Date(dataset[key].startsfrom))
  ) {
    return dfn
      .eachYearOfInterval({
        start: new Date(dataset[key].startsfrom),
        end: new Date(),
      })
      .map((d) => ({
        start: d,
        end: dfn.lastDayOfYear(dfn.addYears(dataset[key].maxInterval - 1, d)),
      }))
      .filter((d) => new Date(d.end).getFullYear() <= new Date().getFullYear())
      .map((d) => ({
        ...d,
        display: `${format(new Date(d.start), "dd LLL yyyy", {
          locale: dateLocales["ro"],
        })} - ${format(new Date(d.end), "dd LLL yyyy", {
          locale: dateLocales["ro"],
        })}`,
      }));
  } else {
    return [];
  }
}
const YearRangeSelector = ({
  ugKey,
  dataSet,
}: {
  ugKey: any;
  dataSet: any;
}) => {
  const { setPeriod } = localMywo;
  const [selRange, setSelRange] = useState<number>(-1);
  const commonTextEditOptions = {
    ...commonStyle({ elementclass: "filledunderline" }),
  };
  const dSize = dataSet.length;
  const spinBeforeOptions = {
    elementAttr: {
      class: "year-spin",
    },
    icon: "spinprev",
    onClick: () => {
      if (selRange === -1) {
        setSelRange(dSize - 2);
        return;
      }
      setSelRange((p) => p - 1);
    },
    disabled: selRange === 0,
  };

  const spinAfterOptions = {
    elementAttr: {
      class: "year-spin",
    },
    icon: "spinnext",
    onClick: () => {
      if (selRange === -1) {
        return;
      }
      if (selRange === dSize - 2) {
        setSelRange(-1);
        return;
      }
      setSelRange((p) => p + 1);
    },
    disabled: selRange === -1,
  };
  useEffect(() => {
    setPeriod(ugKey, {
      start: dfn.format("yyyy-MM-dd", new Date(dataSet.at(selRange)?.start)),
      end: dfn.format("yyyy-MM-dd", new Date(dataSet.at(selRange)?.end)),
    });
  }, [selRange]);
  return (
    <TextBox
      inputAttr={commonTextEditOptions.inputAttr}
      elementAttr={commonTextEditOptions.elementAttr}
      className={"rog-myw-crit user"}
      value={dataSet.at(selRange)?.display}
      stylingMode={"underlined"}
      label={"Perioada de selectie"}
      labelMode={"static"}
    >
      <TextBoxButton
        name="prev_user"
        location="before"
        options={spinBeforeOptions}
      />
      <TextBoxButton
        name="next_user"
        location="after"
        options={spinAfterOptions}
      />
    </TextBox>
  );
};
const InfoLabel = ({ option }: { option: any }) => {
  if (!option) {
    return (
      <div className="dev-mode-show">
        <div className="dev-mode-hash">
          <span style={{ display: "flex" }}>
            <i className="dx-icon-info" />
          </span>
          {"se vor selecta toate datele disponibile"}
        </div>
      </div>
    );
  }
  return (
    <div className="dev-mode-show">
      <div className="dev-mode-hash">
        <span style={{ display: "flex" }}>
          <i className="dx-icon-info" />
        </span>
        {`se pot selecta intervale de ${option.maxInterval} ${
          option.maxInterval === 1 ? "an" : "ani"
        }, 
                 incepand cu ${format(
                   new Date(option.startsfrom),
                   "dd LLL yyyy",
                   {
                     locale: dateLocales["ro"],
                   }
                 )}`}
      </div>
    </div>
  );
};
export const MyworkCriteria = ({ list }: { list: ILxReportOption }) => {
  // The plan : MANAGE A MICRO STATE WITH  RESSO //
  // on initialize, load the state from the store
  // next, manage  the state in local state
  // on finish, dispatch the state to the store

  const ref = useRef(null);
  const { selectedTab, selectedIndex } = localMywo;
  const { t } = useTranslation();

  const theMywCriteria = useAppSelector((s) =>
    listQueryStateCondOptionsForListByName(s, list.name)
  );
  const dataSource = useMemo(() => {
    return Object.entries(theMywCriteria)
      .filter(([key, value]) => value || ({} as TMyworkSelectorCrit0))
      .map(([key, value]) => ({
        TITLE: key,
        ...(value as TMyworkSelectorCrit0),
      }));
  }, [JSON.stringify(theMywCriteria)]);

  const uData = useMemo(() => {
    return createYearIntervals(theMywCriteria, "USER");
  }, [JSON.stringify(theMywCriteria)]);

  const gData = useMemo(() => {
    return createYearIntervals(theMywCriteria, "GROUP");
  }, [JSON.stringify(theMywCriteria)]);

  const itemTitleRender = useCallback((option: any) => {
    return (
      <Switch value={option.TITLE}>
        <Case when={"USER"}>
          <div className={"rop-tab-title"}>{t("mywork_user")}</div>
        </Case>
        <Case when={"GROUP"}>
          <div className={"rop-tab-title"}>{t("mywork_group")}</div>
        </Case>
      </Switch>
    );
  }, []);

  const MyworkCriteriaItem = (option: TMyworkSelectorCrit) => {
    return (
      <div className={"rop-tab"}>
        <Switch value={option.maxInterval}>
          <Case when={[(n: number) => n]}>
            <Switch value={option.TITLE}>
              <Case when={"USER"}>
                <YearRangeSelector ugKey={option.TITLE} dataSet={uData} />
                <div className="break" />
                <InfoLabel option={option} />
              </Case>
              <Case when={"GROUP"}>
                <YearRangeSelector ugKey={option.TITLE} dataSet={gData} />
                <div className="break" />
                <InfoLabel option={option} />
              </Case>
            </Switch>
          </Case>
          <CaseElse>
            <InfoLabel option={null} />
          </CaseElse>
        </Switch>
      </div>
    );
  };

  const tabSelectionChanged = useCallback((e: any) => {
    if (e.name === "selectedIndex") {
      localMywo.selectedIndex = e.value;
      localMywo.selectedTab = dataSource[e.value]?.TITLE as any;
    }
  }, []);

  useEffect(() => {
    if (ref.current) {
      if (dataSource.find((d) => d.TITLE === "GROUP")) {
        localMywo.selectedTab = "GROUP";
        localMywo.selectedIndex = 1;
      } else {
        localMywo.selectedTab = "USER";
        localMywo.selectedIndex = 0;
      } //issue: this should call a render

      // init the period selector
      if (uData.length > 0) {
        localMywo.uSelectedPeriod.start = dfn.format(
          "yyyy-MM-dd",
          new Date(uData[0].start)
        );
        localMywo.uSelectedPeriod.end = dfn.format(
          "yyyy-MM-dd",
          new Date(uData[0].end)
        );
      }
      if (gData.length > 0) {
        localMywo.gSelectedPeriod.start = dfn.format(
          "yyyy-MM-dd",
          new Date(gData[0].start)
        );
        localMywo.gSelectedPeriod.end = dfn.format(
          "yyyy-MM-dd",
          new Date(gData[0].end)
        );
      }
    }
  }, []);

  return (
    <TabPanel
      ref={ref}
      className={"tabs-criteria"}
      height={140}
      keyExpr={"TITLE"}
      dataSource={dataSource}
      // selectedItemKeys={[selectedTab]}
      selectedIndex={selectedIndex}
      loop={false}
      animationEnabled={true}
      focusStateEnabled={false}
      onOptionChanged={tabSelectionChanged}
      itemTitleRender={itemTitleRender}
      itemRender={MyworkCriteriaItem}
    />
  );
};

export const CurrencyPicker = ({ list }: { list: ILxReportOption }) => {
  const { selectedCurrency } = localInvoices;
  // const [selected, setSelected] = useState(['RON']);
  const curr = ["RON", "EUR", "USD", "GBP", "CHF"];
  // useFxSelector(schema.currencies.select);
  //  useAppSelector(selectMonede);
  const buttons = useMemo(() => {
    return curr.map((c: string) => ({
      name: c,
      text: c,
    }));
  }, [JSON.stringify(curr)]);
  const currencyChanged = useCallback((e: any) => {
    localInvoices.selectedCurrency = e.itemData.name;
  }, []);
  return (
    <div style={{ display: "flex", padding: "5px" }}>
      <div style={{ padding: "5px 10px 5px 10px", minWidth: "30%" }}>
        {"Moneda totaluri:"}
      </div>
      <ButtonGroup
        items={buttons}
        keyExpr="name"
        stylingMode="text"
        selectedItemKeys={[selectedCurrency]}
        onItemClick={currencyChanged}
      />
    </div>
  );
};
export const OrganizatonPicker = ({ list }: { list: ILxReportOption }) => {
  const { selectedEmitent } = localInvoices;
  const theOrganizationCrit = useAppSelector((s) =>
    listQueryStateCondOptionsForListByName(s, list.name)
  );
  useEffect(() => {
    if (theOrganizationCrit && theOrganizationCrit.length > 0) {
      if (selectedEmitent === "") {
        localInvoices.selectedEmitent = theOrganizationCrit[0]?.ABR;
      }
    }
  }, [JSON.stringify(theOrganizationCrit)]);

  const onselectionchanged = useCallback((e: any) => {
    localInvoices.selectedEmitent = e.selectedItem?.ABR;
  }, []);

  return (
    <div style={{ display: "flex", padding: "5px" }}>
      <div style={{ padding: "5px 10px 5px 10px", minWidth: "30%" }}>
        {"Emitentul: "}
      </div>
      <SelectBox
        style={{ width: "100%", margin: "auto" }}
        dataSource={theOrganizationCrit}
        displayExpr="DENUMIRE"
        valueExpr="ABR"
        value={selectedEmitent}
        onSelectionChanged={onselectionchanged}
      />
    </div>
  );
};

export const Selection = ({ list }: { list: ILxReportOption }) => {
  /* 
   How to use:
   - in firebird : there is TABLE KARMA_LIST_REPORTS (
   ...
   B_GRIDSTATE BLOB SUB_TYPE 1
   ...
   - the content of the blob is the grid state
   - the grid state is a json string
   - the json contains a key "selectionOptions" of type object
   
   when you create a new list report, you can set the selectionOptions
   e.g "selectionOptions":{"STARTING_LETTER": "A"} -> manuallyDefinedCriteria
   or with no default option, or whatever you want
   - here we interpret those keys and values and render the selection options
   note: If the "selectionOptions" key is not present or is empty object, 
   then the selection is not rendered at all!!!
 
   note: update 15 dec 2022 - for the mywork for example we have done special procedure
   to calculate the custom interval of the selection criteria option.
   In such case we should  not rely on the selectionOptions key but use the
   dedicated component to be rendered

  // MANUALLY ADD OPTIONS:
   note: update 3 feb 2023 - adding proforma options - currency
  
   // PROGRAMATICALLY ADDING OPTIONS:
  note: update 3 feb 2023 -  adding invoice options - issuer - [EMITENTI]
    if we need to programatically show the selection options, we have to define
    a key in reducer --> listApi ---> "criteria" then follow the  "theShowConditionsAreMet"  
      ::( uiLists.ts -> lxInvoiceCriteria  and build some query to get the data
      then update that key  [`criteria/${ENDPOINT_LIST_OF_INVOICES}`] ....
      then pass through the selection options in uiLists and here.

   */
  //  THANK YOU FOR WRITING THIS COMMENT :) //

  const theShowConditionsAreMet = useAppSelector((s) =>
    listQueryStateShowConditionForListByName(s, list.name)
  );
  // TESTING WITH DEV_MYWOPTS:
  // console.log('theShowConditionsAreMet', theShowConditionsAreMet);
  // const manuallyDefinedCriteria = !isEmpty( list.selectionOptions);
  // you can leave this for production:
  const manuallyDefinedCriteria = !isEmpty(
    omit(list.selectionOptions, ["DEV_MYWOPTS"])
  );

  const showCriteria = useMemo(
    () => [
      () => theShowConditionsAreMet, // from code via custom proc: [lxMyWorkCriteria]
      () => manuallyDefinedCriteria, // from BLOB field in DB
    ],
    [list.name]
  );

  const showConditons = useCallback(() => {
    return showCriteria.map((x) => x()).includes(true);
  }, [list.selectionOptions, list.name]);

  //importatnt css class to hide the selection
  if (!showConditons()) {
    return <div className="rop-selections-hidden" />;
  }
  const options =
    typeof list.selectionOptions === "string"
      ? list.selectionOptions
      : Object.keys(ensureArray(list.selectionOptions));

  return (
    <div className="rop-acc-selection">
      <Switch value={true}>
        {/* <Case
          when={[
            () => !theShowConditionsAreMet && options.includes('DEV_MYWOPTS'),
          ]}
        >
          <MyworkCriteria list={list} />
          <div className="dev-mode-show">
            <i className="dx-icon-variable" style={{ fontSize: '1.1rem' }} />
            {'DEV MODE FORCED SHOW . in progress!!!'}
          </div>
        </Case> */}
        <Case
          when={[
            () =>
              theShowConditionsAreMet &&
              list.name.startsWith(CONST_LISTORIGIN_WORK),
          ]}
        >
          <MyworkCriteria list={list} />
        </Case>
        <Case when={[() => options.includes("YEAR_PICKER")]}>
          {/* THIS YEAR PICKER STUFF IS HERE FOR EXAMPLE ONLY */}
          <Calendar
            maxZoomLevel={"decade"}
            minZoomLevel={"decade"}
            defaultValue={new Date()}
            max={new Date()}
          />
        </Case>
        <Case when={[() => options.includes("STARTING_WITH")]}>
          <i className="dx-icon-bookmark" />
        </Case>
        <Case when={[() => options.includes("CURRENCY_PICKER")]}>
          <CurrencyPicker list={list} />
        </Case>
        <Case
          when={[
            () =>
              theShowConditionsAreMet &&
              list.name.startsWith(CONST_LISTORIGIN_INVOICE),
          ]}
        >
          <OrganizatonPicker list={list} />
        </Case>
      </Switch>
    </div>
  );
};
